import { Badge as BadgePrimitive } from '@/components/ui/Badge';
import { cn } from '@/lib/utils';

import { BADGE_CLASS, BADGE_TONE, sizingClass } from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

export const Badge: ComponentFn<typeof catalog, 'Badge'> = ({ props }) =>
  props.text ? (
    <BadgePrimitive
      variant="secondary"
      className={cn(
        BADGE_CLASS,
        BADGE_TONE[props.tone ?? 'neutral'],
        sizingClass(props.sizing) || 'shrink-0'
      )}
    >
      {props.text}
    </BadgePrimitive>
  ) : null;
